module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-MdCn.e4c76a57.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/Helvetica/HelveticaNeueLTStd-MdCn.otf
// module id = 876
// module chunks = 0